export default __webpack_public_path__ + "static/media/4.64b6fc3a.pdf";